/**
 * Takes input for cronschedule and enabled. Has a submit button to push values to jobActions.
 *
 * @prettier
 * @author Russell Lilljedahl
 */

import React from 'react'
import { Field, reduxForm } from 'redux-form'
import LgyInputField from 'app/components/util/lgy-input-field/LgyInputField'
import LgySelectField from 'app/components/util/lgy-select-field/LgySelectField'
import lgySelectFieldNormalizer from 'app/components/util/lgy-select-field/lgySelectFieldNormalizer'
import { LgySubsection } from 'app/components/util/lgy-section/LgySection'
import LgyTooltip from 'app/components/util//lgy-tooltip/LgyTooltip'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'
import validations from 'app/utils/validations'
import { validateCron, validateMultipleEmails } from 'app/utils/validations'

const JobModificationForm = ({ job, submitting, handleSubmit, isSuccess, submitSucceeded, submitFailed }) => (
  <div>
    <LgySubsection name='jobModificationForm' header={`Modify ${job.name}`} className='usa-table-borderless'>
      {(isSuccess || submitSucceeded) && (
        <LgyAlertDialog type='success' heading='Job Updated' text='The job was updated successfully.' />
      )}
      {submitFailed && (
        <LgyAlertDialog
          type='error'
          heading='Job Not Updated'
          text='The job was not updated. Check that your input is valid.'
        />
      )}
      <form onSubmit={handleSubmit}>
        <div>
          <table className='usa-table-borderless'>
            <thead>
              <tr>
                <th scope='col'>Function</th>
                <th scope='col'>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <b>
                    <label htmlFor='enabled'>
                      Enable or Disable
                      <LgyTooltip message='Select whether to enable or disable the job' id='enableJob-tip' />
                    </label>
                  </b>
                </td>
                <td>
                  <Field
                    id='enabled'
                    name='isEnabled'
                    type='select'
                    component={LgySelectField}
                    validate={validations.requiredDropdown}
                    normalize={lgySelectFieldNormalizer}
                    required
                  >
                    <option value='true'>Enabled</option>
                    <option value='false'>Disabled</option>
                  </Field>
                </td>
              </tr>
              <tr>
                <td>
                  <b>
                    <label htmlFor='cron'>
                      Job Schedule
                      <LgyTooltip
                        message='Will this job be on a schedule or ran manually? To run on a schedule, enter in CRON format. Type MANUAL if you do not want it scheduled and would rather run manually.'
                        id='jobSchedule-tip'
                      />
                    </label>
                  </b>
                </td>
                <td>
                  <Field
                    id='cron'
                    name='cronSchedule'
                    type='text'
                    component={LgyInputField}
                    validate={[validations.required, validateCron]}
                    required
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <b>
                    <label htmlFor='successEmail'>
                      Success Email
                      <LgyTooltip
                        message='If the job is a success, where should the email be sent? Values must be comma or semi-colon separated.'
                        id='success-email-tip'
                      />
                    </label>
                  </b>
                </td>
                <td>
                  <Field
                    id='successEmail'
                    name='successEmail'
                    type='text'
                    component={LgyInputField}
                    validate={[validations.required, validateMultipleEmails]}
                    required
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <b>
                    <label htmlFor='failureEmail'>
                      Failure Email
                      <LgyTooltip
                        message='If the job is a failure, where should the email be sent? Values must be comma or semi-colon separated.'
                        id='failure-email-tip'
                      />
                    </label>
                  </b>
                </td>
                <td>
                  <Field
                    id='failureEmail'
                    name='failureEmail'
                    type='text'
                    component={LgyInputField}
                    validate={[validations.required, validateMultipleEmails]}
                    required
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <b>
                    <label htmlFor='fromEmail'>
                      From Email
                      <LgyTooltip
                        message='Where should the email be sent from? Only one email allowed.'
                        id='from-email-tip'
                      />
                    </label>
                  </b>
                </td>
                <td>
                  <Field
                    id='fromEmail'
                    name='fromEmail'
                    type='text'
                    component={LgyInputField}
                    validate={[validations.required, validations.email]}
                    required
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <button className='usa-button job-update-button' type='submit' value='Update' disabled={submitting}>
            {submitting ? 'Updating...' : 'Update'}
          </button>
        </div>
      </form>
    </LgySubsection>
  </div>
)

export default reduxForm({})(JobModificationForm)
